/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Medicine from './medicine';
import MedicineDetail from './medicine-detail';
import MedicineUpdate from './medicine-update';
import MedicineDeleteDialog from './medicine-delete-dialog';

const MedicineRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Medicine />} />
    <Route path="new" element={<MedicineUpdate />} />
    <Route path=":id">
      <Route index element={<MedicineDetail />} />
      <Route path="edit" element={<MedicineUpdate />} />
      <Route path="delete" element={<MedicineDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MedicineRoutes;
